import React from 'react';
import { useReveal } from '../lib/useReveal';
const ROADBLOCKS = [{
  emoji: '🧭',
  text: 'No sabés por dónde empezar ni qué ruta elegir.'
}, {
  emoji: '🎒',
  text: 'Te abruma todo lo que “parece” necesario llevar.'
}, {
  emoji: '🌦️',
  text: 'El clima cambia y no sabés cómo leer las señales.'
}, {
  emoji: '⛰️',
  text: 'Querés progresar, pero no conocés tus límites todavía.'
}];
export function ProblemSection() {
  const [ref1, vis1] = useReveal();
  return <section className="border-t border-white/5 bg-[#17231c] px-4 py-14 md:py-20" data-id="element-222" data-mp="39jqo48dbo5ga">
      <div ref={ref1} className={`reveal container mx-auto max-w-3xl text-center ${vis1 ? 'is-visible' : ''}`} data-id="element-223" data-mp="35g0wtb59j9rk">
        <p className="mb-4 text-sm font-bold uppercase tracking-[0.22em] text-[#e6a45c]" data-id="element-224" data-mp="3jdpmqxe6t73h">La incertidumbre no es un plan</p>
        <h2 className="mb-6 font-serif text-3xl font-bold leading-tight text-white md:text-5xl" data-id="element-225" data-mp="1p1snii9i6wxv">La montaña no se conquista.<br data-id="element-226" data-mp="1k3r7y7badfr5" />Se aprende a transitar.</h2>
        <p className="mx-auto mb-9 max-w-2xl font-serif text-xl leading-relaxed text-stone-300" data-id="element-227" data-mp="1k4sh268qrs68">Salir sin preparación puede transformar una gran experiencia en una situación incómoda —o riesgosa. Empezar bien es disfrutar más.</p>
        <div className="grid grid-cols-1 gap-3 text-left sm:grid-cols-2" data-id="element-228" data-mp="sdtgnjxt7o1g">
          {ROADBLOCKS.map(item => <div key={item.text} className="flex items-center gap-4 rounded-xl border border-white/10 bg-[#101914] p-5" data-id="element-229" data-mp="x4i9p3p50t2p"><span className="text-2xl" data-id="element-230" data-mp="123v2e52owud7">{item.emoji}</span><span className="text-base font-medium text-stone-200" data-id="element-231" data-mp="123376vd08yng">{item.text}</span></div>)}
        </div>
      </div>
    </section>;
}